import React from "react";

const LoaderComponent = () => {
  return (
    <div className="container">
      <p>Loading</p>
    </div>
  );
};

export default LoaderComponent;
